import { Injectable } from '@angular/core';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import { GenericRoteirizadorService } from './generic-roteirizador.service';
import { UserToken } from '../auth';
import { Observable } from 'rxjs';
import {UsuarioDTO, UsuarioMotoristaParametroDTO} from 'src/app/content/pages/models/usuario.model';
import {TiposUsuarioNomeCompletoEnum} from '../../content/pages/enums/tipo-usuario-enum';

@Injectable({ providedIn: 'root' })
export class UsuariosService extends GenericRoteirizadorService {

  constructor(
    private mensagensService: MensagensService,
    private httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/usuarios';
  }

  consultarUsuarioPorId(idUsuario) {
    return this.get<any>('/consultarUsuarioPorId', {
      dados: { id: idUsuario }
    });
  }

  consultarUsuarioEmprPorId(idUsuario) {
    return this.get<any>('/consultarUsuarioEmprPorId', {
      dados: { id: idUsuario }
    });
  }

  ativarUsuario(usuario: any) {
    return this.post('/ativar', {
      dados: {
        id: usuario.id
      },
      enviarComoQueryString: true
    });
  }

  inativarUsuario(usuario: any) {
    return this.post('/inativar', {
      dados: {
        id: usuario.id
      },
      enviarComoQueryString: true
    });
  }

  getUserToken() {
    return this.get<UserToken>('/getUserToken');
  }

  getAppInfo() {
    return this.get<any>('/app');
  }

  pesquisarUsuariosRoteirizador(filtros: any): Observable<any[]> {
    return this.get<any>('/pesquisarUsuariosRoteirizador', {
      dados: filtros
    });
  }

  tiposFuncionario() {
    return this.get<any[]>('/tiposFuncionario');
  }

  salvar(value: any) {
    return this.post('/salvar', { dados: value });
  }

  consultarPorTipoEAtivo(filtros): Observable<UsuarioDTO[]> {
    return this.post<any>('/consultarPorTipoEAtivo', {
      dados: filtros,
    });
  }

  consultarUsuarioGenericoPorTipo(filtros): Observable<UsuarioDTO[]> {
    return this.post<any>('/consultarUsuarioGenericoPorTipo', {
      dados: filtros,
    });
  }

  listarUsuariosParametroPortalByFilial(idParametro: string, idFilial: string, tiposUsuario?: string[]): Observable<UsuarioMotoristaParametroDTO[]> {
    return this.get<UsuarioMotoristaParametroDTO[]>('/listarUsuariosParametroPortalByFilial', {
      dados: {
        idParametro,
        idFilial,
        tiposUsuario
      }
    });
  }
}
